const getSquare = () => (window.Cypress ? window.testSquare() : window.Square);

export default getSquare;
